import { render, staticRenderFns } from "./Provider.vue?vue&type=template&id=5d3c51cb&scoped=true&"
import script from "./Provider.vue?vue&type=script&lang=js&"
export * from "./Provider.vue?vue&type=script&lang=js&"
import style0 from "./Provider.vue?vue&type=style&index=0&id=5d3c51cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3c51cb",
  null
  
)

export default component.exports